import { Send } from 'lucide-react'
import React, { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import {
  automatedSubmissionMethodOptions,
  manualSubmissionMethodOptions,
} from '../EditEnrollmentData'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const manualSubmissionMethodFilterOptions = manualSubmissionMethodOptions.map(
  ({ value, label }) => ({
    label: label as string,
    value,
  })
)

const automatedSubmissionMethodFilterOptions =
  automatedSubmissionMethodOptions.map(({ value, label }) => ({
    label: label as string,
    value,
  }))

const submissionMethodOptions: ComboboxFilterOption<string>[] = [
  ...manualSubmissionMethodFilterOptions,
  ...automatedSubmissionMethodFilterOptions,
]

const SubmissionMethodFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredManualOptions = manualSubmissionMethodFilterOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  const filteredAutomatedOptions =
    automatedSubmissionMethodFilterOptions?.filter(
      filterByLabelAndValueCallback(query)
    )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          {
            groupLabel: 'Manual',
            options: filteredManualOptions || [],
          },
          {
            groupLabel: 'Automated',
            options: filteredAutomatedOptions || [],
          },
        ]}
        placeholder='Search submission methods to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={submissionMethodOptions || []}
          noSelectionText='Submission Method'
          pluralIdentifier='submission methods'
        >
          <Send size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default SubmissionMethodFilter
